// Knowledge center articles (multi-lang). Cover is a tint hue used by the SVG cover.

export const ARTICLE_CATEGORIES = [
  "supplementation",
  "nutrition",
  "sport",
  "wellness",
  "science",
];

const RAW = [
  {
    id: "mg-3-forms",
    category: "supplementation",
    hue: 250,
    readMins: 5,
    icon: "pill",
    title: {
      es: "Magnesio: las 3 formas que valen tu dinero",
      en: "Magnesium: the 3 forms worth your money",
      fr: "Magnésium : les 3 formes qui valent votre argent",
      ca: "Magnesi: les 3 formes que val el teu diners",
    },
    excerpt: {
      es: "Bisglicinato, malato y citrato — cuándo usar cada uno y por qué evitar el óxido.",
      en: "Bisglycinate, malate and citrate — when to pick each and why to skip oxide.",
      fr: "Bisglycinate, malate, citrate — lequel choisir et pourquoi éviter l'oxyde.",
      ca: "Bisglicinat, malat i citrat — quan usar cadascun i per què evitar l'òxid.",
    },
  },
  {
    id: "fiber-ldl",
    category: "nutrition",
    hue: 140,
    readMins: 6,
    icon: "apple",
    title: {
      es: "Por qué la fibra soluble baja el LDL (y dónde encontrarla)",
      en: "Why soluble fiber lowers LDL (and where to find it)",
      fr: "Pourquoi la fibre soluble baisse le LDL (et où la trouver)",
      ca: "Per què la fibra soluble baixa el LDL (i on trobar-la)",
    },
    excerpt: {
      es: "Avena, legumbres, manzana y psyllium: mecanismo y dosis efectiva diaria.",
      en: "Oats, legumes, apple, psyllium: mechanism and effective daily dose.",
      fr: "Avoine, légumineuses, pomme, psyllium : mécanisme et dose quotidienne.",
      ca: "Civada, llegums, poma i psyllium: mecanisme i dosi diària efectiva.",
    },
  },
  {
    id: "walk-after-meal",
    category: "sport",
    hue: 25,
    readMins: 4,
    icon: "dumbbell",
    title: {
      es: "Caminar 10 minutos después de comer: el truco para tu glucosa",
      en: "A 10-minute walk after eating: the trick for your glucose",
      fr: "10 minutes de marche après le repas : l'astuce pour votre glycémie",
      ca: "Caminar 10 minuts després de menjar: el truc per la teva glucosa",
    },
    excerpt: {
      es: "Reduce el pico postprandial entre un 12 y un 22%. Sin gimnasio, sin excusas.",
      en: "Cuts post-meal spike by 12 to 22%. No gym, no excuses.",
      fr: "Réduit le pic post-prandial de 12 à 22%. Sans salle, sans excuses.",
      ca: "Redueix el pic postprandial entre un 12 i un 22%. Sense gimnàs.",
    },
  },
  {
    id: "sleep-hygiene-6",
    category: "wellness",
    hue: 280,
    readMins: 7,
    icon: "heart",
    title: {
      es: "Higiene del sueño: protocolo en 6 puntos",
      en: "Sleep hygiene: a 6-point protocol",
      fr: "Hygiène du sommeil : protocole en 6 points",
      ca: "Higiene del son: protocol en 6 punts",
    },
    excerpt: {
      es: "Luz, temperatura, cafeína y rituales: lo que separa una noche reparadora de una mediocre.",
      en: "Light, temperature, caffeine, rituals: what makes a night restorative.",
      fr: "Lumière, température, caféine, rituels : ce qui fait une nuit réparatrice.",
      ca: "Llum, temperatura, cafeïna i rituals: el que separa una bona nit d'una mediocre.",
    },
  },
  {
    id: "vitamin-d-why",
    category: "science",
    hue: 50,
    readMins: 6,
    icon: "flask",
    title: {
      es: "Vitamina D: por qué medirla y qué hacer con el resultado",
      en: "Vitamin D: why measure it and what to do with the result",
      fr: "Vitamine D : pourquoi la mesurer et que faire du résultat",
      ca: "Vitamina D: per què mesurar-la i què fer amb el resultat",
    },
    excerpt: {
      es: "Diferencias entre 25-OH y 1,25-OH, rangos óptimos y estrategias de suplementación.",
      en: "Difference between 25-OH and 1,25-OH, optimal ranges, supplementation strategies.",
      fr: "Différence 25-OH vs 1,25-OH, plages optimales et stratégies de supplémentation.",
      ca: "Diferències entre 25-OH i 1,25-OH, rangs òptims i estratègies de suplementació.",
    },
  },
  {
    id: "omega-3-epa-dha",
    category: "supplementation",
    hue: 200,
    readMins: 5,
    icon: "pill",
    title: {
      es: "Omega 3: ¿EPA, DHA o ambos?",
      en: "Omega 3: EPA, DHA or both?",
      fr: "Oméga 3 : EPA, DHA ou les deux ?",
      ca: "Omega 3: EPA, DHA o tots dos?",
    },
    excerpt: {
      es: "Qué papel juega cada uno y cómo elegir tu suplemento sin perderte en las etiquetas.",
      en: "Role of each and how to pick your supplement without label confusion.",
      fr: "Rôle de chacun et comment choisir sans se perdre dans les étiquettes.",
      ca: "Quin paper juga cadascun i com triar el teu suplement sense perdre't.",
    },
  },
  {
    id: "tre-evidence",
    category: "nutrition",
    hue: 160,
    readMins: 6,
    icon: "apple",
    title: {
      es: "Comer en 8 horas: lo que dice la evidencia",
      en: "Eating in an 8-hour window: what the evidence says",
      fr: "Manger sur 8 heures : ce que dit la science",
      ca: "Menjar en 8 hores: el que diu l'evidència",
    },
    excerpt: {
      es: "Time-restricted eating: beneficios reales, mitos y para quién no es buena idea.",
      en: "Time-restricted eating: real benefits, myths and who should avoid it.",
      fr: "Alimentation à fenêtre restreinte : bénéfices, mythes, contre-indications.",
      ca: "Alimentació en finestra restringida: beneficis, mites i contraindicacions.",
    },
  },
  {
    id: "strength-after-35",
    category: "sport",
    hue: 0,
    readMins: 8,
    icon: "dumbbell",
    title: {
      es: "Entrenamiento de fuerza después de los 35",
      en: "Strength training after 35",
      fr: "Musculation après 35 ans",
      ca: "Entrenament de força després dels 35",
    },
    excerpt: {
      es: "Cómo preservar masa muscular, hueso y testosterona con 2 sesiones por semana.",
      en: "Preserve muscle, bone and testosterone with 2 sessions per week.",
      fr: "Préserver muscle, os et testostérone avec 2 séances par semaine.",
      ca: "Com preservar massa muscular, ossos i testosterona amb 2 sessions setmanals.",
    },
  },
  {
    id: "bio-age",
    category: "science",
    hue: 240,
    readMins: 7,
    icon: "flask",
    title: {
      es: "Edad biológica: qué mide y qué no",
      en: "Biological age: what it measures (and what it doesn't)",
      fr: "Âge biologique : ce qu'il mesure (et pas)",
      ca: "Edat biològica: què mesura i què no",
    },
    excerpt: {
      es: "Relojes epigenéticos, índices clínicos y por qué tu analítica ya da una pista útil.",
      en: "Epigenetic clocks, clinical indices, and why your bloodwork already hints at it.",
      fr: "Horloges épigénétiques, indices cliniques, et ce que dit votre analyse.",
      ca: "Rellotges epigenètics, índexs clínics i per què la teva analítica ja en dóna una pista.",
    },
  },
];

export function getArticles(lang = "es") {
  return RAW.map((a) => ({
    id: a.id,
    category: a.category,
    hue: a.hue,
    readMins: a.readMins,
    icon: a.icon,
    title: a.title[lang] || a.title.es,
    excerpt: a.excerpt[lang] || a.excerpt.es,
  }));
}
